import React from "react";

function Home() {
  return (
    <div className="container text-center my-5">
      <h1 className="my-5">Welcome!</h1>
      <h3>You are currently the view Home Page</h3>
    </div>
  );
}
export default Home;
